
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, InjectFunction } from "@common/src/utils/decorator";
import CardConsumeDialog from "./components/consume-detail-dialog.vue";
import _ from "lodash-es";
import t from "@common/src/i18n/t";
import { formDownload } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const base = namespace("base");
const marketing = namespace("marketing");

@InjectFunction(
  "dayjs",
  "emptyToLine",
  "splitThousands",
  "permit",
  "permitApp",
  "appCode",
  "addCurrencySymbol",
  "addCurrencyUnit"
)
@Component({ components: { CardConsumeDialog, TextTips } })
@Table("loadListData")
export default class PreDepositIndex extends Vue {
  @base.Action getDictionaryList;
  @marketing.Action queryCardTemplateList;
  @marketing.Action queryPreDepositList;
  depositList: any[] = [];
  searchForm = {
    cardCode: "",
    customerName: "",
    customerMobile: "",
    cardType: "",
    cardTemplateCode: "",
    transactionType: "",
    transactionTimeBegin: "",
    transactionTimeEnd: ""
  };
  created() {
    this.init();
    this.loadListData();
    this.searchCardTemplate("");
  }
  cardTemplateTypeList = [];
  transactionTypeList = [];
  init() {
    this.getDictionaryList("card_type").then(data => {
      this.cardTemplateTypeList = data;
    });
    this.getDictionaryList("card_report_transaction_type").then(data => {
      this.transactionTypeList = data;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryPreDepositList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.depositList = data.data?.list;
      this.sumData = _.omit(data.data, ["list", "total"]);
      return data;
    });
  }
  get searchList() {
    return [
      {
        label: t("v3_4_0.transaction-time"),
        type: "daterange",
        prop: "transactionTimeBegin",
        value: "",
        valueDistribute: ["transactionTimeBegin", "transactionTimeEnd"]
      },
      {
        label: t("marketing.card-num"),
        type: "input",
        value: "",
        prop: "cardCode"
      },
      {
        label: t("finance.guest-names"),
        type: "input",
        value: "",
        prop: "customerName"
      },
      {
        label: t("finance.mobile"),
        type: "input",
        value: "",
        prop: "customerMobile"
      },
      {
        label: t("marketing.card-type"),
        type: "select",
        selectList: this.cardTemplateTypeList,
        value: "",
        prop: "cardType"
      },
      {
        label: t("marketing.card-name"),
        type: "select-search",
        selectList: this.cardTemplateList,
        searchFun: this.searchCardTemplate,
        value: "",
        prop: "cardTemplateCode"
      },
      {
        label: t("v3_4_0.transaction-type"),
        type: "select",
        selectList: this.transactionTypeList,
        value: "",
        prop: "transactionType"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }

  activeRow: any = {};
  cardTemplateList = [];
  searchCardTemplate(searchKey = "") {
    this.queryCardTemplateList({
      pageSize: 20,
      pageNum: 1,
      cardTemplateName: searchKey,
      containsCustomized: "1"
    }).then(res => {
      this.cardTemplateList = (res.data?.list || []).map(item => {
        item.label = item.cardTemplateName;
        item.value = item.cardTemplateCode;
        return item;
      });
    });
  }
  sumData = {};
  handleShowDetail(row) {
    this.activeRow = row;
    (this.$refs.CardConsumeDialog as any).open();
  }
  handleCardView(row) {
    window.open(this.$router.resolve(`/marketing/card-view/${row.cardCode}`).href);
  }
  handleExportData() {
    formDownload(`${window.API_URL}/card/cardReport/queryList/download`, this.searchForm);
  }
}
